//Auto-add CSRF Token to requests
$.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    jqXHR.setRequestHeader('X-CSRF-Token', $('meta[name=csrf-token]').attr('content'));
});

// String.prototype.ucFirst = function() {
//   return this.charAt(0).toUpperCase() + this.slice(1)
// }


// Array.prototype.findKey = function ( key, val ) {
//     for( var i in this ) {
//         if( this[i][key] == val ) {
//             return this[i];
//         }
//     }

//     return false;
// };
//Refresh CSRF
setInterval( ()=>{

    // $.ajax({
    //     url : '/_rftkn',
    //     type: "POST",
    //     data : {},
    //     success( token ){
    //         $('meta[name="csrf_token"]').attr('content',token);

    //         $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
    //             jqXHR.setRequestHeader('X-CSRF-Token', token);
    //         });
    //     }
    // })

}, 300000); 

//URBO Notifications style
$.notify.addStyle('urbo', {
    html: "<div> <span data-notify-text/> </div>",
    classes: {
        base: {
            "white-space": "nowrap",
            "background-color": "#D4A35F",
            "padding": "20px",
            "font-weight" : 'bolder',
            "color": "white",
            "z-index": "99",
        },

        success : {
            "background-color": "rgba(44, 142, 75, 1);"
        },

        warning : {
            "background-color": "rgba(247, 172, 65, 1)"
        },

        error : {
            "background-color": "rgba(239, 62, 62, 1)"
        }
    }
});

$.notify.defaults({ style: "urbo" });

$(document).ready(function() {
    $('.nav-link.marker').on('click', function (e) {
        var marker = $("#marker");

        if( !marker.length ) {
            var marker = $("<li id='marker'></li>");
        }

        marker.css('left', e.target.offsetLeft + e.target.offsetWidth / 4 + "px");
        marker.css('width', e.target.offsetWidth / 2 + "px");

        marker.appendTo( $(this).closest('ul') );
    });

    $( "#closeVerify" ).on( "click", function(e) {

        $( "#verifyEmail" ).addClass( "d-none" );
        
    });
    
    
    // Responsive Menu
    // Function adding overfow on body on click on buttons
    function menuResponsive() {
        var menu1 = '#responsive-menu';
        var menu2 = '#profile-menu'; 
        $(this).toggleClass('this');

        if ( $(menu1).hasClass('this') || $(menu2).hasClass('this') ) {
            $("body").addClass("overflow");
            $(".responsive-bottom").removeClass("shadow-lg");
        } else {
            $("body").removeClass("overflow");
            $(".responsive-bottom").addClass("shadow-lg");
        }
    }

    // Responsive Menu Button
    $('#responsive-menu').click(function(){
        $('#profile-menu').removeClass('this');
    });

    $('#responsive-menu').click(menuResponsive);

    // Profile menu button
    $('#profile-menu').click(function(){
        $('#responsive-menu').removeClass('this');
    });

    $('#profile-menu').click(menuResponsive);

    // Removing body overflow, when click outside of the buttons
    $(document).click(function(event){       

        if(!$(event.target).closest("#responsive-menu").length || !$(event.target).closest("#profile-menu").length){

            $("body").removeClass("overflow");
            $(".responsive-bottom").addClass("shadow-lg");
        }
    });


    // Activate Bootstrap Popovers
    $("body").popover({ 
        selector: '[data-toggle=popover]',
        html: true
    });
    $('body').on('click', function (e) {
        //did not click a popover toggle or popover
        if ($(e.target).data('toggle') !== 'popover'
            && $(e.target).parents('.popover.in').length === 0) { 
            $('[data-toggle="popover"]').popover('hide');
        }
    });

    // Responsive Menu

    $('#btn-timeline').click(function(){
        $('.project-timeline-holder').addClass('slide');
        $('body').addClass('hidden-overflow');
    });

    $("body").on('click',"#close-timeline", function(){
        $('.project-timeline-holder').removeClass('slide');
        $('body').removeClass('hidden-overflow');
    });


    $(function() {
        var header = $("#main-menu");

        function checkScroll() {
            var scroll = $(window).scrollTop();
            
            if (scroll >= 10) {
                header.addClass("bg-white");
                header.addClass("shadow-lg");
            } else {
                header.removeClass("bg-white");
                header.removeClass("shadow-lg");
            }
        }

        checkScroll();
        $(window).scroll(checkScroll);

        // var rellax = new Rellax('.rellax');

    });

    // Timeline Button Fixed on responsive
    if ( $(window).width() < 992 ) {
        
        if( typeof $('#btn-timeline').offset() != 'object' ) {
            return;
        }
        
        var fixmeTop = $('#btn-timeline').offset().top;

        $(window).scroll(function() {
            
            var currentScroll = $(window).scrollTop();

            if ( currentScroll >= fixmeTop ) {

                $('#btn-timeline').addClass('fixed-top');
                $('#btn-timeline').addClass('btn-secondary');
                $('#btn-timeline').addClass('shadow');
                $('#btn-timeline').removeClass('btn-outline-secondary');
          
            } else {

                $('#btn-timeline').removeClass('fixed-top');
                $('#btn-timeline').removeClass('btn-secondary');
                $('#btn-timeline').removeClass('shadow');
                $('#btn-timeline').addClass('btn-outline-secondary');
            }

        });
    }

    

});